/**
 * Created by Jerker Nord on 2023-10-05.
 */
import {Loner} from "../../../Loner";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";

export class LonerTickTickBoomStartPresentation implements SimplePresentation{

    private _controller: SimplePresentationRunnerController;

    public shouldRun(): boolean {
        return (Loner.model.data.mode == LonerGameMode.NORMAL && Loner.model.data.nextMode == LonerGameMode.FEATURE_TICK_TICK_BOOM);
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        Loner.tickTickBoomView.start(() => this.complete());
    }

    private complete(): void {
        this._controller.finish();
    }
}